var _ChatClipboardServiceInit_currentImage;
import { __classPrivateFieldGet } from "tslib";
import { writable } from 'svelte/store';
class ChatClipboardServiceInit {
    constructor() {
        _ChatClipboardServiceInit_currentImage.set(this, writable(null));
    }
    get currentImage() {
        return __classPrivateFieldGet(this, _ChatClipboardServiceInit_currentImage, "f");
    }
    setCurrentImage(image) {
        __classPrivateFieldGet(this, _ChatClipboardServiceInit_currentImage, "f").set(image);
    }
}
_ChatClipboardServiceInit_currentImage = new WeakMap();
export const ChatClipboardService = new ChatClipboardServiceInit();
